import {getUnverifiedToken} from '@sail/data';
import type {StripeContextInput} from '../../../schema/types';
import {API_KEY, ID, TYPE, LIVE_MODE} from './constants';
import type {AccountUnverifiedToken} from './types';

export default function getAccountUnverifiedToken(
  id?: NonNullable<StripeContextInput['id']>,
  liveMode?: NonNullable<StripeContextInput['liveMode']>,
  apiKey?: NonNullable<StripeContextInput['apiKey']>,
): AccountUnverifiedToken {
  return {
    ...getUnverifiedToken(),
    [API_KEY]: apiKey,
    [ID]: id,
    [TYPE]: 'ACCOUNT',
    [LIVE_MODE]: liveMode,
  };
}
